/**
 * This file was auto-generated
 * Do not edit manually
 */

import {
	amountFormatter,
	amountWithCodeFormatter,
	shortFormatter,
	shortWithDateFormatter,
	monthAndYearFormatter,
	dateAndTimeFormatter,
	shortDateAndTimePreciseFormatter,
	relativeFormatter,
	agoFormatter,
	monthFormatter,
	plural,
	TranslationAmount,
	DateInput
} from './i18n-util'

export const en = {
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('en', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('en', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('en', arg1)
	},
	Date: {
		Short: (arg0: DateInput) => shortFormatter('en', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('en', arg0),
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('en', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('en', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('en', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('en', arg0),
		Ago: (arg0: DateInput) => agoFormatter('en', arg0, () => locales['en'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('en', arg0)
	},
	TimeAgo: {
		JustNow: () => 'just now',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'minute', other: 'minutes' }) + ' ago',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'hour', other: 'hours' }) + ' ago',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'day', other: 'days' }) + ' ago',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'month', other: 'months' }) + ' ago',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'year', other: 'years' }) + ' ago'
	},
	Common: {
		Actions: {
			Add: () => 'Add',
			Remove: () => 'Remove',
			Edit: () => 'Edit',
			Delete: () => 'Delete',
			Save: () => 'Save',
			Cancel: () => 'Cancel',
			Submit: () => 'Submit',
			Continue: () => 'Continue',
			Back: () => 'Back',
			Next: () => 'Next',
			Confirm: () => 'Confirm',
			Close: () => 'Close',
			ViewDetails: () => 'View Details',
			ViewAll: () => 'View All',
			Retry: () => 'Try Again',
			Skip: () => 'Skip'
		},
		States: {
			Loading: () => 'Loading',
			Empty: () => 'No items found',
			Error: () => 'Something went wrong',
			Success: () => 'Success',
			Failed: () => 'Failed',
			Pending: () => 'Pending',
			Completed: () => 'Completed'
		},
		Sorting: {
			Ascending: () => 'Ascending',
			Descending: () => 'Descending',
			SortBy: () => 'Sort by',
			Newest: () => 'Newest',
			Oldest: () => 'Oldest',
			PriceLowToHigh: () => 'Price: Low to High',
			PriceHighToLow: () => 'Price: High to Low',
			Popular: () => 'Most Popular'
		},
		Filters: {
			Filter: () => 'Filter',
			ClearAll: () => 'Clear All',
			Apply: () => 'Apply',
			Reset: () => 'Reset'
		}
	},
	Navigation: {
		Home: () => 'Home',
		Products: () => 'Products',
		Cart: () => 'Cart',
		Account: () => 'Account',
		Orders: () => 'Orders',
		Search: () => 'Search',
		Menu: () => 'Menu',
		Categories: () => 'Categories',
		More: (arg0: number) => 'More (' + String(arg0) + ')',
		CategoriesCount: (arg0: number) => 'Categories (' + String(arg0) + ')'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			'Showing ' + String(args.start) + ' to ' + String(args.end) + ' of ' + String(args.total) + ' results',
		Previous: () => 'Previous',
		Next: () => 'Next'
	},
	Product: {
		Details: {
			Title: () => 'Product Details',
			Description: () => 'Description',
			Specifications: () => 'Specifications',
			Reviews: () => 'Reviews',
			RelatedProducts: () => 'Related Products',
			InStock: () => 'In Stock',
			OutOfStock: () => 'Out of Stock',
			LowStock: (arg0: number) => 'Only ' + String(arg0) + ' left',
			AddToCart: () => 'Add to Cart',
			BuyNow: () => 'Buy Now',
			Quantity: () => 'Quantity',
			Price: () => 'Price',
			OriginalPrice: () => 'Original Price',
			SalePrice: () => 'Sale Price',
			Discount: (arg0: number) => String(arg0) + '% off'
		},
		Catalog: {
			Title: () => 'Products',
			All: () => 'All',
			SearchPlaceholder: () => 'Search products...',
			NoResults: () => 'No products found',
			NoResultsForQuery: (args: { query: string }) => 'No products found for "' + String(args.query) + '"',
			ShowingResults: (arg0: number, arg1: number) =>
				'Showing ' + String(arg0) + ' of ' + String(arg1) + ' products',
			LoadMore: () => 'Load More Products',
			Category: () => 'Category',
			Brand: () => 'Brand',
			PriceRange: () => 'Price Range'
		}
	},
	Onboarding: {
		FirstStep: {
			Title: () => 'Add product to cart',
			Description: () =>
				'Browse or search to find products, and add them to the cart. You can easily adjust the amount, or read more about the product.'
		},
		SecondStep: {
			Title: () => 'Go to payment',
			Description: () => 'Complete the purchase by paying with card.'
		},
		ThirdStep: {
			Title: () => 'Done!',
			Description: () => 'Get a digital receipt of your purchase and pick up your order.'
		},
		Next: () => 'Next',
		Back: () => 'Back',
		Complete: () => 'Start shopping',
		Continue: () => 'Continue',
		WelcomeTitle: (args: { name: string }) => 'Welcome to ' + String(args.name),
		WelcomeSubtitle: () => 'Great to see you!',
		WelcomeMessage: () => 'Sign in to collect rewards and view your receipts.',
		GetStarted: () => 'Get Started',
		LoginTitle: () => 'Sign In',
		LoginSubtitle: () => 'Sign in with your phone number.',
		LoyaltyTitle: () => 'Collect rewards',
		LoyaltyDescription: () => 'Take advantage of offers and collect rewards with every purchase.',
		WalletTitle: () => 'Add card to wallet',
		WalletDescription: () => 'Add your loyalty card to your phone wallet to save time at checkout.',
		ReceiptsTitle: () => 'Receipts',
		ReceiptsDescription: () => 'Have an overview of your purchases and access your receipts anytime.',
		AddToWallet: () => 'Add to wallet',
		SkipAddingToWallet: () => 'Skip',
		TermsTitle: () => 'Terms & Conditions',
		TermsDescription: () => 'Please read and accept the terms to continue.',
		TermsAgreePrefix: () => 'I have read and accept the terms',
		PrivacyPolicyAgreePrefix: () => 'I have read and accept the privacy policy',
		TermsAndConditions: () => 'Read terms',
		PrivacyPolicy: () => 'Read privacy policy',
		TermsUpdatedTitle: () => 'Terms & Privacy updated',
		TermsUpdatedDescription: () =>
			'We have updated our Terms & Conditions and Privacy Policy. To continue, you need to accept the following.',
		TermsLink: () => 'Read Terms & Conditions',
		PrivacyLink: () => 'Read Privacy Policy',
		TermsUpdatedAccept: () => 'I agree'
	},
	Cart: {
		Title: () => 'Shopping Cart',
		Empty: () => 'Your cart is empty',
		ItemCount: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'item', other: 'items' }),
		AddItem: () => 'Add to Cart',
		RemoveItem: () => 'Remove from Cart',
		UpdateQuantity: () => 'Update Quantity',
		ClearCart: () => 'Clear Cart',
		Subtotal: () => 'Subtotal',
		Tax: () => 'Tax',
		Shipping: () => 'Shipping',
		Total: () => 'Total',
		Checkout: () => 'Proceed to Checkout',
		ContinueShopping: () => 'Continue Shopping',
		QuantityLabel: () => 'Qty',
		UnitPrice: () => 'Unit Price',
		ItemTotal: () => 'Item Total',
		ViewCart: () => 'View Cart',
		Pay: (arg0: TranslationAmount) => 'Pay ' + amountFormatter('en', arg0),
		PayWith: (arg0: 'CASH' | 'CASH_ASYNC' | 'ADYEN_ECOM' | 'VERIFONE_CHECKOUT' | 'VERIFONE_ECOM') =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Pay with cash'
					case 'CASH_ASYNC':
						return 'Pay with cash (async)'
					case 'ADYEN_ECOM':
						return 'Pay with card'
					case 'VERIFONE_CHECKOUT':
						return 'Pay with card'
					case 'VERIFONE_ECOM':
						return 'Pay with card'
					default:
						return String(v)
				}
			})(arg0),
		ProcessingPayment: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Processing Payment'
					case 'CANCELLING':
						return 'Cancelling Payment'
					case 'INITIALIZING':
						return 'Initializing Payment'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PleaseWait: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Please wait while we confirm your payment...'
					case 'CANCELLING':
						return 'Please wait while we cancel your payment...'
					case 'INITIALIZING':
						return 'Please wait while we initialize your payment...'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PaymentError: () => 'Payment Error',
		PaymentSuccessfullyCancelled: () => 'Payment successfully cancelled',
		PaymentFailed: () => 'Payment failed. Please try again.',
		PaymentExpired: () => 'Payment expired. Please try again.',
		PaymentInfoCouldNotBeRetrieved: () => 'Payment information could not be retrieved. Please try again.',
		PaymentInitiationTimedOut: () => 'Setting up the payment timed out. Please try again.'
	},
	Checkout: {
		Title: () => 'Checkout',
		Steps: {
			Shipping: () => 'Shipping',
			Payment: () => 'Payment',
			Review: () => 'Review',
			Confirmation: () => 'Confirmation'
		},
		Shipping: {
			Address: () => 'Shipping Address',
			Method: () => 'Shipping Method',
			FirstName: () => 'First Name',
			LastName: () => 'Last Name',
			AddressLine1: () => 'Address',
			AddressLine2: () => 'Apartment, suite, etc. (optional)',
			City: () => 'City',
			PostalCode: () => 'Postal Code',
			Country: () => 'Country',
			Phone: () => 'Phone Number'
		},
		Review: {
			OrderSummary: () => 'Order Summary',
			ShippingInfo: () => 'Shipping Information',
			PaymentInfo: () => 'Payment Information',
			PlaceOrder: () => 'Place Order'
		}
	},
	Orders: {
		Title: () => 'Order History',
		Empty: () => 'No orders found',
		OrderNumber: (arg0: string) => 'Order #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Ordered on ' + shortFormatter('en', arg0),
		Status: {
			Pending: () => 'Pending',
			Processing: () => 'Processing',
			Shipped: () => 'Shipped',
			Delivered: () => 'Delivered',
			Cancelled: () => 'Cancelled',
			Refunded: () => 'Refunded'
		},
		TrackOrder: () => 'Track Order',
		Reorder: () => 'Reorder',
		ViewReceipt: () => 'View Receipt',
		OrderDetails: () => 'Order Details'
	},
	Receipt: {
		Title: () => 'Receipt',
		TitleWithOrderNumber: (arg0: string) => 'Receipt ' + String(arg0),
		NotFound: () => 'Receipt not found.',
		OrderId: () => 'Order ID',
		OrderNumber: (arg0: string) => '#' + String(arg0),
		Total: () => 'Total',
		DownloadPDF: () => 'Download PDF',
		PickupCode: () => 'Pickup Code',
		PickupCodeMessage: () => 'Show this code to pick up your order.',
		ShowPickupCode: () => 'Show Pickup Code',
		BackToReceipts: () => 'Back to Receipts'
	},
	Receipts: {
		Title: () => 'Previous Orders',
		Empty: () => 'No orders found',
		OrderNumber: (arg0: string) => 'Order #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Ordered on ' + shortFormatter('en', arg0),
		Items: (args: { count: number }) =>
			String(args.count) + ' ' + plural('en', args.count, { one: 'item', other: 'items' }),
		ViewReceipt: () => 'View Receipt',
		BackToHome: () => 'Back to Home',
		MoreItems: (arg0: number) => '+' + String(arg0),
		Unknown: () => 'Unknown'
	},
	Auth: {
		SignIn: () => 'Sign In',
		SignUp: () => 'Sign Up',
		SignOut: () => 'Sign Out',
		Email: () => 'Email',
		Password: () => 'Password',
		ConfirmPassword: () => 'Confirm Password',
		ForgotPassword: () => 'Forgot Password?',
		CreateAccount: () => 'Create Account',
		AlreadyHaveAccount: () => 'Already have an account?',
		DontHaveAccount: () => "Don't have an account?",
		ResetPassword: () => 'Reset Password',
		RememberMe: () => 'Remember me',
		PhoneNumber: () => 'Phone number',
		SSN: () => 'SSN',
		TaktikalPhoneMethod: () => 'Electronic ID',
		TaktikalSsnMethod: () => 'Authentication app',
		VerificationCode: (arg0: string) => 'Verification code: ' + String(arg0),
		SignInToYourAccount: () => 'Sign in to your account',
		SignIntoYourAccountDescription: () => 'Sign in to view your loyalty card, receipts, and more.',
		Continue: () => 'Continue',
		AuthenticationTimedOut: () => 'Authentication request timed out. Please try again.',
		Retry: () => 'Retry'
	},
	LoyaltyCard: {
		Title: () => 'Loyalty Card',
		NoCard: () => 'No loyalty card found',
		CardNumber: () => 'Card number',
		AvailablePoints: () => 'Available points',
		AddToWallet: () => 'Add to wallet',
		ShowReceipts: () => 'View receipts',
		Disclaimer: () => 'Points are valid for 3 years from the date you earned them.',
		JoinProgram: () => 'Join loyalty program',
		JoinBenefitsTitle: () => 'Join our loyalty program',
		JoinBenefitPoints: () => 'Collect points on every purchase',
		JoinBenefitOffers: () => 'Get access to exclusive member offers',
		PointsHistory: () => 'Points history',
		EmptyHistory: () => 'No point history yet'
	},
	Profile: {
		Language: () => 'Language',
		Logout: () => 'Log out',
		LogoutConfirm: () => 'Log out',
		LogoutConfirmMessage: () => 'Are you sure you want to log out?',
		DeleteAccount: () => 'Delete account',
		DeleteAccountConfirm: () => 'Delete account',
		DeleteAccountConfirmMessage: () =>
			'Are you sure you want to delete your account? This action cannot be undone.',
		DeleteAccountFinalConfirm: () => 'Are you absolutely sure?',
		DeleteAccountFinalConfirmMessage: () =>
			'This is permanent and irreversible. All your data will be deleted. There is no going back.',
		DeleteAccountConfirmButton: () => 'Yes, delete my account'
	},
	Errors: {
		Generic: () => 'Something went wrong. Please try again.',
		Network: () => 'Network error. Please check your connection.',
		NotFound: () => 'Page not found',
		Unauthorized: () => 'Please sign in to continue',
		Validation: {
			Required: () => 'This field is required',
			InvalidEmail: () => 'Please enter a valid email address',
			PasswordTooShort: () => 'Password must be at least 8 characters',
			PasswordsDoNotMatch: () => 'Passwords do not match',
			InvalidFormat: () => 'Invalid format'
		}
	}
}

export const is = {
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('is', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('is', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('is', arg1)
	},
	Date: {
		Short: (arg0: DateInput) => shortFormatter('is', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('is', arg0),
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('is', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('is', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('is', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('is', arg0),
		Ago: (arg0: DateInput) => agoFormatter('is', arg0, () => locales['is'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('is', arg0)
	},
	TimeAgo: {
		JustNow: () => 'núna',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'mínútu', other: 'mínútum' }) + ' síðan',
		HoursAgo: (args: { count: number }) =>
			String(args.count) +
			' ' +
			plural('is', args.count, { one: 'klukkustund', other: 'klukkustundum' }) +
			' síðan',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'degi', other: 'dögum' }) + ' síðan',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'mánuði', other: 'mánuðum' }) + ' síðan',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'ári', other: 'árum' }) + ' síðan'
	},
	Common: {
		Actions: {
			Add: () => 'Bæta við',
			Remove: () => 'Fjarlægja',
			Edit: () => 'Breyta',
			Delete: () => 'Eyða',
			Save: () => 'Vista',
			Cancel: () => 'Hætta við',
			Submit: () => 'Senda',
			Continue: () => 'Halda áfram',
			Back: () => 'Til baka',
			Next: () => 'Næsta',
			Confirm: () => 'Staðfesta',
			Close: () => 'Loka',
			ViewDetails: () => 'Skoða nánar',
			ViewAll: () => 'Skoða allt',
			Retry: () => 'Reyna aftur',
			Skip: () => 'Sleppa'
		},
		States: {
			Loading: () => 'Hleður',
			Empty: () => 'Ekkert fannst',
			Error: () => 'Eitthvað fór úrskeiðis',
			Success: () => 'Tókst',
			Failed: () => 'Mistókst',
			Pending: () => 'Í bið',
			Completed: () => 'Lokið'
		},
		Sorting: {
			Ascending: () => 'Hækkandi',
			Descending: () => 'Lækkandi',
			SortBy: () => 'Raða eftir',
			Newest: () => 'Nýjast',
			Oldest: () => 'Elst',
			PriceLowToHigh: () => 'Verð: Lágt til hátt',
			PriceHighToLow: () => 'Verð: Hátt til lágt',
			Popular: () => 'Vinsælast'
		},
		Filters: {
			Filter: () => 'Sía',
			ClearAll: () => 'Hreinsa allt',
			Apply: () => 'Virkja',
			Reset: () => 'Endurstilla'
		}
	},
	Navigation: {
		Home: () => 'Heim',
		Products: () => 'Vörur',
		Cart: () => 'Karfa',
		Account: () => 'Aðgangur',
		Orders: () => 'Pantanir',
		Search: () => 'Leit',
		Menu: () => 'Valmynd',
		Categories: () => 'Flokkar',
		More: (arg0: number) => 'Fleiri (' + String(arg0) + ')',
		CategoriesCount: (arg0: number) => 'Flokkar (' + String(arg0) + ')'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			'Sýni ' + String(args.start) + ' til ' + String(args.end) + ' af ' + String(args.total) + ' niðurstöðum',
		Previous: () => 'Fyrri',
		Next: () => 'Næsta'
	},
	Product: {
		Details: {
			Title: () => 'Upplýsingar um vöru',
			Description: () => 'Lýsing',
			Specifications: () => 'Tæknilegar upplýsingar',
			Reviews: () => 'Umsagnir',
			RelatedProducts: () => 'Skyldar vörur',
			InStock: () => 'Til á lager',
			OutOfStock: () => 'Uppselt',
			LowStock: (arg0: number) => 'Aðeins ' + String(arg0) + ' eftir',
			AddToCart: () => 'Setja í körfu',
			BuyNow: () => 'Kaupa núna',
			Quantity: () => 'Magn',
			Price: () => 'Verð',
			OriginalPrice: () => 'Upprunalegt verð',
			SalePrice: () => 'Tilboðsverð',
			Discount: (arg0: number) => String(arg0) + '% afsláttur'
		},
		Catalog: {
			Title: () => 'Vörur',
			All: () => 'Allt',
			SearchPlaceholder: () => 'Leita að vörum...',
			NoResults: () => 'Engar vörur fundust',
			NoResultsForQuery: (args: { query: string }) => 'Engar vörur fundust fyrir "' + String(args.query) + '"',
			ShowingResults: (arg0: number, arg1: number) => 'Sýni ' + String(arg0) + ' af ' + String(arg1) + ' vörum',
			LoadMore: () => 'Hlaða fleiri vörum',
			Category: () => 'Flokkur',
			Brand: () => 'Vörumerki',
			PriceRange: () => 'Verðbil'
		}
	},
	Onboarding: {
		FirstStep: {
			Title: () => 'Settu í körfu',
			Description: () =>
				'Skrunaðu um vefinn eða leitaðu af vöru, smelltu á plúsinn og varan fer í körfuna þína. Þú bætir svo við eða minnkar magnið með því að smella á plús eða mínus.'
		},
		SecondStep: {
			Title: () => 'Borga með korti',
			Description: () => 'Kláraðu kaupin með því að smella á borga og setja inn kortaupplýsingarnar þínar.'
		},
		ThirdStep: {
			Title: () => 'Klárt!',
			Description: () => 'Farðu að afgreiðsluborðinu, sýndu kvittunina og fáðu afhent.'
		},
		Next: () => 'Áfram',
		Back: () => 'Til baka',
		Complete: () => 'Byrja að versla',
		Continue: () => 'Halda áfram',
		WelcomeTitle: (args: { name: string }) => 'Velkomin/n í ' + String(args.name),
		WelcomeSubtitle: () => 'Gaman að sjá þig!',
		WelcomeMessage: () => 'Skráðu þig inn til að safna inneign og skoða tilboð!',
		GetStarted: () => 'Byrja',
		LoginTitle: () => 'Innskráning',
		LoginSubtitle: () => 'Skráðu þig inn með símanúmerinu þínu.',
		LoyaltyTitle: () => 'Safnaðu inneign',
		LoyaltyDescription: () => 'Nýttu þér tilboð og safnaðu inneign með hverri kaup.',
		WalletTitle: () => 'Bæta korti við veski',
		WalletDescription: () => 'Bættu vildarkorti þínu við símavestinguna til að spara tíma við greiðslu.',
		ReceiptsTitle: () => 'Kvittanir',
		ReceiptsDescription: () => 'Fáðu yfirlit yfir kaup þín og aðgang að kvittunum hvenær sem er.',
		AddToWallet: () => 'Setja í veski',
		SkipAddingToWallet: () => 'Sleppa',
		TermsTitle: () => 'Skilmálar',
		TermsDescription: () => 'Lestu nú vel yfir skilmálana og samþykktu þá til að halda áfram.',
		TermsAgreePrefix: () => 'Ég hef lesið og samþykki skilmála',
		PrivacyPolicyAgreePrefix: () => 'Ég hef lesið og samþykki persónuverndarstefnu',
		TermsAndConditions: () => 'Lesa skilmála',
		PrivacyPolicy: () => 'Lesa persónuverndarstefnu',
		TermsUpdatedTitle: () => 'Smáa letrið uppfært',
		TermsUpdatedDescription: () =>
			'Við höfum uppfært skilmála og persónuverndarstefnu. Til að halda áfram þarftu að samþykkja eftirfarandi.',
		TermsLink: () => 'Lesa skilmála',
		PrivacyLink: () => 'Lesa persónuverndarstefnu',
		TermsUpdatedAccept: () => 'Ég samþykki'
	},
	Cart: {
		Title: () => 'Innkaupakarfa',
		Empty: () => 'Karfan er tóm',
		ItemCount: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'vara', other: 'vörur' }),
		AddItem: () => 'Setja í körfu',
		RemoveItem: () => 'Fjarlægja úr körfu',
		UpdateQuantity: () => 'Breyta magni',
		ClearCart: () => 'Tæma körfu',
		Subtotal: () => 'Samtals',
		Tax: () => 'Skattur',
		Shipping: () => 'Sendingarkostnaður',
		Total: () => 'Heildarupphæð',
		Checkout: () => 'Fara í greiðslu',
		ContinueShopping: () => 'Halda áfram að versla',
		QuantityLabel: () => 'Magn',
		UnitPrice: () => 'Einingaverð',
		ItemTotal: () => 'Heildarverð',
		ViewCart: () => 'Skoða körfu',
		Pay: (arg0: TranslationAmount) => 'Greiða ' + amountFormatter('is', arg0),
		PayWith: (arg0: 'CASH' | 'CASH_ASYNC' | 'ADYEN_ECOM' | 'VERIFONE_CHECKOUT' | 'VERIFONE_ECOM') =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Greiða með reiðufé'
					case 'CASH_ASYNC':
						return 'Greiða með reiðufé (async)'
					case 'ADYEN_ECOM':
						return 'Greiða með korti'
					case 'VERIFONE_CHECKOUT':
						return 'Greiða með korti'
					case 'VERIFONE_ECOM':
						return 'Greiða með korti'
					default:
						return String(v)
				}
			})(arg0),
		ProcessingPayment: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Vinnum úr greiðslu'
					case 'CANCELLING':
						return 'Hættum við greiðslu'
					case 'INITIALIZING':
						return 'Setjum upp greiðslu'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PleaseWait: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Vinsamlegast bíðið á meðan við staðfestum greiðsluna...'
					case 'CANCELLING':
						return 'Vinsamlegast bíðið á meðan við hættum greiðslu...'
					case 'INITIALIZING':
						return 'Vinsamlegast bíðið á meðan við setjum upp greiðslu...'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PaymentError: () => 'Villa í greiðslu',
		PaymentSuccessfullyCancelled: () => 'Hætt við greiðslu',
		PaymentFailed: () => 'Greiðsla mistókst. Vinsamlegast reyndu aftur.',
		PaymentExpired: () => 'Greiðsla rann út á tíma. Vinsamlegast reyndu aftur.',
		PaymentInfoCouldNotBeRetrieved: () => 'Greiðsluupplýsingar fannst ekki. Vinsamlegast reyndu aftur.',
		PaymentInitiationTimedOut: () => 'Uppsetning greiðslu mistókst. Vinsamlegast reyndu aftur.'
	},
	Checkout: {
		Title: () => 'Greiðsla',
		Steps: {
			Shipping: () => 'Sending',
			Payment: () => 'Greiðsla',
			Review: () => 'Yfirlit',
			Confirmation: () => 'Staðfesting'
		},
		Shipping: {
			Address: () => 'Sendingarfang',
			Method: () => 'Sendingaraðferð',
			FirstName: () => 'Fornafn',
			LastName: () => 'Eftirnafn',
			AddressLine1: () => 'Heimilisfang',
			AddressLine2: () => 'Íbúð, hús, o.fl. (valfrjálst)',
			City: () => 'Bær',
			PostalCode: () => 'Póstnúmer',
			Country: () => 'Land',
			Phone: () => 'Símanúmer'
		},
		Review: {
			OrderSummary: () => 'Yfirlit pöntunar',
			ShippingInfo: () => 'Sendingarupplýsingar',
			PaymentInfo: () => 'Greiðsluupplýsingar',
			PlaceOrder: () => 'Staðfesta pöntun'
		}
	},
	Orders: {
		Title: () => 'Pöntunarferill',
		Empty: () => 'Engar pantanir fundust',
		OrderNumber: (arg0: string) => 'Pöntun #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Pantað þann ' + shortFormatter('is', arg0),
		Status: {
			Pending: () => 'Í bið',
			Processing: () => 'Í vinnslu',
			Shipped: () => 'Sent',
			Delivered: () => 'Afhent',
			Cancelled: () => 'Aflýst',
			Refunded: () => 'Endurgreitt'
		},
		TrackOrder: () => 'Rekja pöntun',
		Reorder: () => 'Panta aftur',
		ViewReceipt: () => 'Skoða kvittun',
		OrderDetails: () => 'Nánar um pöntun'
	},
	Receipt: {
		Title: () => 'Kvittun',
		TitleWithOrderNumber: (arg0: string) => 'Kvittun ' + String(arg0),
		NotFound: () => 'Kvittun fannst ekki.',
		OrderId: () => 'Pöntun nr.',
		OrderNumber: (arg0: string) => '#' + String(arg0),
		Total: () => 'Samtals',
		DownloadPDF: () => 'Sækja PDF',
		ShowPickupCode: () => 'Sýna afhendingarkóða',
		PickupCodeMessage: () => 'Sýndu þennan kóða til að fá pöntunina afhenta.',
		PickupCode: () => 'Afhendingarkóði',
		BackToReceipts: () => 'Til baka í kvittanalista'
	},
	Receipts: {
		Title: () => 'Kvittanir',
		Empty: () => 'Engar pantanir fundust',
		OrderNumber: (arg0: string) => 'Pöntun #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Pantað þann ' + shortFormatter('is', arg0),
		Items: (args: { count: number }) =>
			String(args.count) + ' ' + plural('is', args.count, { one: 'vara', other: 'vörur' }),
		ViewReceipt: () => 'Skoða kvittun',
		BackToHome: () => 'Til baka á forsíðu',
		MoreItems: (arg0: number) => '+' + String(arg0),
		Unknown: () => 'Óþekkt'
	},
	Auth: {
		SignIn: () => 'Skrá inn',
		SignUp: () => 'Skrá sig',
		SignOut: () => 'Skrá út',
		Email: () => 'Netfang',
		SSN: () => 'Kennitala',
		Password: () => 'Lykilorð',
		ConfirmPassword: () => 'Staðfesta lykilorð',
		ForgotPassword: () => 'Gleymt lykilorð?',
		CreateAccount: () => 'Búa til aðgang',
		AlreadyHaveAccount: () => 'Ertu með aðgang?',
		DontHaveAccount: () => 'Ertu ekki með aðgang?',
		ResetPassword: () => 'Endurstilla lykilorð',
		RememberMe: () => 'Muna eftir mér',
		PhoneNumber: () => 'Símanúmer',
		TaktikalPhoneMethod: () => 'Rafræn skilríki',
		TaktikalSsnMethod: () => 'Auðkennisapp',
		VerificationCode: (arg0: string) => 'Staðfestingarkóði: ' + String(arg0),
		SignInToYourAccount: () => 'Skráðu þig inn á reikninginn þinn',
		SignIntoYourAccountDescription: () =>
			'Skráðu þig inn til að safna inneign og fá aðgang að kvittunum og fleiru.',
		Continue: () => 'Halda áfram',
		AuthenticationTimedOut: () => 'Auðkenning rann út á tíma. Vinsamlegast reyndu aftur.',
		Retry: () => 'Reyna aftur'
	},
	LoyaltyCard: {
		Title: () => 'Vildarkort',
		CardNumber: () => 'Kortanúmer',
		AvailablePoints: () => 'Punktar í boði',
		AddToWallet: () => 'Bæta í veskið',
		ShowReceipts: () => 'Sjá kvittanir',
		Disclaimer: () => 'Inneign fyrnist á þremur árum frá því að þú vannst þér hana inn.',
		JoinProgram: () => 'Skrá í vildarkerfi',
		JoinBenefitsTitle: () => 'Vertu með í vildarkerfinu',
		JoinBenefitPoints: () => 'Safnaðu punktum í hvert skipti sem þú verslar',
		JoinBenefitOffers: () => 'Fáðu persónuleg tilboð',
		PointsHistory: () => 'Punktasaga',
		EmptyHistory: () => 'Engin punktanotkun enn',
		NoCard: () => 'Ekkert vildarkort enn!'
	},
	Profile: {
		Language: () => 'Tungumál',
		Logout: () => 'Skrá út',
		LogoutConfirm: () => 'Skrá út',
		LogoutConfirmMessage: () => 'Ertu viss um að þú viljir skrá þig út?',
		DeleteAccount: () => 'Eyða aðgangi',
		DeleteAccountConfirm: () => 'Eyða aðgangi',
		DeleteAccountConfirmMessage: () => 'Ertu viss um að þú viljir eyða aðganginum þínum? Þetta er óafturkræft.',
		DeleteAccountFinalConfirm: () => 'Ertu algerlega viss?',
		DeleteAccountFinalConfirmMessage: () =>
			'Þetta er varanlegt og óafturkræft. Öllum gögnum þínum verður eytt. Engin leið til baka.',
		DeleteAccountConfirmButton: () => 'Já, eyða aðganginum mínum'
	},
	Errors: {
		Generic: () => 'Eitthvað fór úrskeiðis. Vinsamlegast reyndu aftur.',
		Network: () => 'Netvilla. Vinsamlegast athugaðu nettengingu.',
		NotFound: () => 'Síða fannst ekki',
		Unauthorized: () => 'Vinsamlegast skráðu þig inn til að halda áfram',
		Validation: {
			Required: () => 'Þessi reitur er áskilinn',
			InvalidEmail: () => 'Vinsamlegast sláðu inn gilt netfang',
			PasswordTooShort: () => 'Lykilorð verður að vera að minnsta kosti 8 stafir',
			PasswordsDoNotMatch: () => 'Lykilorð passa ekki saman',
			InvalidFormat: () => 'Ógilt snið'
		}
	}
}

export const nb = {
	Amount: {
		Default: (arg0: TranslationAmount) => amountFormatter('nb', arg0),
		WithCode: (arg0: TranslationAmount) => amountWithCodeFormatter('nb', arg0),
		QuantityTimesPrice: (arg0: number, arg1: TranslationAmount) =>
			String(arg0) + ' × ' + amountFormatter('nb', arg1)
	},
	Date: {
		Short: (arg0: DateInput) => shortFormatter('nb', arg0),
		ShortWithDate: (arg0: DateInput) => shortWithDateFormatter('nb', arg0),
		MonthAndYear: (arg0: DateInput) => monthAndYearFormatter('nb', arg0),
		DateAndTime: (arg0: DateInput) => dateAndTimeFormatter('nb', arg0),
		ShortDateAndTimePrecise: (arg0: DateInput) => shortDateAndTimePreciseFormatter('nb', arg0),
		Relative: (arg0: DateInput) => relativeFormatter('nb', arg0),
		Ago: (arg0: DateInput) => agoFormatter('nb', arg0, () => locales['nb'].TimeAgo),
		Month: (arg0: DateInput) => monthFormatter('nb', arg0)
	},
	TimeAgo: {
		JustNow: () => 'akkurat nå',
		MinutesAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'minutt', other: 'minutter' }) + ' siden',
		HoursAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'time', other: 'timer' }) + ' siden',
		DaysAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'dag', other: 'dager' }) + ' siden',
		MonthsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'måned', other: 'måneder' }) + ' siden',
		YearsAgo: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'år', other: 'år' }) + ' siden'
	},
	Common: {
		Actions: {
			Add: () => 'Legg til',
			Remove: () => 'Fjern',
			Edit: () => 'Rediger',
			Delete: () => 'Slett',
			Save: () => 'Lagre',
			Cancel: () => 'Avbryt',
			Submit: () => 'Send inn',
			Continue: () => 'Fortsett',
			Back: () => 'Tilbake',
			Next: () => 'Neste',
			Confirm: () => 'Bekreft',
			Close: () => 'Lukk',
			ViewDetails: () => 'Se detaljer',
			ViewAll: () => 'Se alle',
			Retry: () => 'Prøv igjen',
			Skip: () => 'Hopp over'
		},
		States: {
			Loading: () => 'Laster',
			Empty: () => 'Ingen elementer funnet',
			Error: () => 'Noe gikk galt',
			Success: () => 'Vellykket',
			Failed: () => 'Mislyktes',
			Pending: () => 'Venter',
			Completed: () => 'Fullført'
		},
		Sorting: {
			Ascending: () => 'Stigende',
			Descending: () => 'Synkende',
			SortBy: () => 'Sorter etter',
			Newest: () => 'Nyeste',
			Oldest: () => 'Eldste',
			PriceLowToHigh: () => 'Pris: Lav til høy',
			PriceHighToLow: () => 'Pris: Høy til lav',
			Popular: () => 'Mest populær'
		},
		Filters: {
			Filter: () => 'Filter',
			ClearAll: () => 'Fjern alle',
			Apply: () => 'Bruk',
			Reset: () => 'Tilbakestill'
		}
	},
	Navigation: {
		Home: () => 'Hjem',
		Products: () => 'Produkter',
		Cart: () => 'Handlekurv',
		Account: () => 'Konto',
		Orders: () => 'Bestillinger',
		Search: () => 'Søk',
		Menu: () => 'Meny',
		Categories: () => 'Kategorier',
		More: (arg0: number) => 'Mer (' + String(arg0) + ')',
		CategoriesCount: (arg0: number) => 'Kategorier (' + String(arg0) + ')'
	},
	Pagination: {
		Showing: (args: { start: number; end: number; total: number }) =>
			'Viser ' + String(args.start) + ' til ' + String(args.end) + ' av ' + String(args.total) + ' resultater',
		Previous: () => 'Forrige',
		Next: () => 'Neste'
	},
	Product: {
		Details: {
			Title: () => 'Produktdetaljer',
			Description: () => 'Beskrivelse',
			Specifications: () => 'Spesifikasjoner',
			Reviews: () => 'Anmeldelser',
			RelatedProducts: () => 'Relaterte produkter',
			InStock: () => 'På lager',
			OutOfStock: () => 'Utsolgt',
			LowStock: (arg0: number) => 'Kun ' + String(arg0) + ' igjen',
			AddToCart: () => 'Legg i handlekurv',
			BuyNow: () => 'Kjøp nå',
			Quantity: () => 'Antall',
			Price: () => 'Pris',
			OriginalPrice: () => 'Opprinnelig pris',
			SalePrice: () => 'Tilbudspris',
			Discount: (arg0: number) => String(arg0) + '% avslag'
		},
		Catalog: {
			Title: () => 'Produkter',
			All: () => 'Alle',
			SearchPlaceholder: () => 'Søk etter produkter...',
			NoResults: () => 'Ingen produkter funnet',
			NoResultsForQuery: (args: { query: string }) => 'Ingen produkter funnet for "' + String(args.query) + '"',
			ShowingResults: (arg0: number, arg1: number) =>
				'Viser ' + String(arg0) + ' av ' + String(arg1) + ' produkter',
			LoadMore: () => 'Last inn flere produkter',
			Category: () => 'Kategori',
			Brand: () => 'Merke',
			PriceRange: () => 'Prisintervall'
		}
	},
	Onboarding: {
		FirstStep: {
			Title: () => 'Legg i handlekurv',
			Description: () =>
				'Bla gjennom eller søk etter produkter, og legg dem i handlekurven. Du kan enkelt justere antallet, eller lese mer om produktet.'
		},
		SecondStep: {
			Title: () => 'Gå til betaling',
			Description: () => 'Fullfør kjøpet ved å betale med kort.'
		},
		ThirdStep: {
			Title: () => 'Ferdig!',
			Description: () => 'Få en digital kvittering for kjøpet ditt og hent bestillingen din.'
		},
		Next: () => 'Neste',
		Back: () => 'Tilbake',
		Complete: () => 'Start å handle',
		Continue: () => 'Fortsett',
		WelcomeTitle: (args: { name: string }) => 'Velkommen til ' + String(args.name),
		WelcomeSubtitle: () => 'Godt å se deg!',
		WelcomeMessage: () => 'Logg inn for å samle poeng og se kvitteringene dine.',
		GetStarted: () => 'Kom i gang',
		LoginTitle: () => 'Logg inn',
		LoginSubtitle: () => 'Logg inn med telefonnummeret ditt.',
		LoyaltyTitle: () => 'Samle poeng',
		LoyaltyDescription: () => 'Dra nytte av tilbud og samle poeng ved hvert kjøp.',
		WalletTitle: () => 'Legg kortet til lommeboken',
		WalletDescription: () => 'Legg lojalitetskortet ditt til telefonlommeboken for å spare tid ved kassen.',
		ReceiptsTitle: () => 'Kvitteringer',
		ReceiptsDescription: () => 'Få en oversikt over kjøpene dine og tilgang til kvitteringene dine når som helst.',
		AddToWallet: () => 'Legg til lommebok',
		SkipAddingToWallet: () => 'Hopp over',
		TermsTitle: () => 'Vilkår og betingelser',
		TermsDescription: () => 'Les og godta vilkårene for å fortsette.',
		TermsAgreePrefix: () => 'Jeg har lest og godtar vilkårene',
		PrivacyPolicyAgreePrefix: () => 'Jeg har lest og godtar personvernreglene',
		TermsAndConditions: () => 'Les vilkår',
		PrivacyPolicy: () => 'Les personvernreglene',
		TermsUpdatedTitle: () => 'Vilkår og personvern oppdatert',
		TermsUpdatedDescription: () =>
			'Vi har oppdatert våre vilkår og betingelser og personvernregler. For å fortsette må du godta følgende.',
		TermsLink: () => 'Les vilkår og betingelser',
		PrivacyLink: () => 'Les personvernreglene',
		TermsUpdatedAccept: () => 'Jeg godtar'
	},
	Cart: {
		Title: () => 'Handlekurv',
		Empty: () => 'Handlekurven er tom',
		ItemCount: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'vare', other: 'varer' }),
		AddItem: () => 'Legg i handlekurv',
		RemoveItem: () => 'Fjern fra handlekurv',
		UpdateQuantity: () => 'Oppdater antall',
		ClearCart: () => 'Tøm handlekurv',
		Subtotal: () => 'Delsum',
		Tax: () => 'Avgift',
		Shipping: () => 'Frakt',
		Total: () => 'Totalt',
		Checkout: () => 'Gå til kassen',
		ContinueShopping: () => 'Fortsett å handle',
		QuantityLabel: () => 'Ant.',
		UnitPrice: () => 'Enhetspris',
		ItemTotal: () => 'Varetotal',
		ViewCart: () => 'Se handlekurv',
		Pay: (arg0: TranslationAmount) => 'Betal ' + amountFormatter('nb', arg0),
		PayWith: (arg0: 'CASH' | 'CASH_ASYNC' | 'ADYEN_ECOM' | 'VERIFONE_CHECKOUT' | 'VERIFONE_ECOM') =>
			(v => {
				switch (v) {
					case 'CASH':
						return 'Betal med kontanter'
					case 'CASH_ASYNC':
						return 'Betal med kontanter (async)'
					case 'ADYEN_ECOM':
						return 'Betal med kort'
					case 'VERIFONE_CHECKOUT':
						return 'Betal med kort'
					case 'VERIFONE_ECOM':
						return 'Betal med kort'
					default:
						return String(v)
				}
			})(arg0),
		ProcessingPayment: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Behandler betaling'
					case 'CANCELLING':
						return 'Avbryter betaling'
					case 'INITIALIZING':
						return 'Initialiserer betaling'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PleaseWait: (arg0: 'PROCESSING' | 'CANCELLING' | 'INITIALIZING' | 'NOT_STARTED') =>
			(v => {
				switch (v) {
					case 'PROCESSING':
						return 'Vennligst vent mens vi bekrefter betalingen...'
					case 'CANCELLING':
						return 'Vennligst vent mens vi avbryter betalingen...'
					case 'INITIALIZING':
						return 'Vennligst vent mens vi initialiserer betalingen...'
					case 'NOT_STARTED':
						return ''
					default:
						return String(v)
				}
			})(arg0),
		PaymentError: () => 'Betalingsfeil',
		PaymentSuccessfullyCancelled: () => 'Betaling avbrutt',
		PaymentFailed: () => 'Betaling mislyktes. Vennligst prøv igjen.',
		PaymentExpired: () => 'Betaling utløpt. Vennligst prøv igjen.',
		PaymentInfoCouldNotBeRetrieved: () => 'Betalingsinformasjon kunne ikke hentes. Vennligst prøv igjen.',
		PaymentInitiationTimedOut: () => 'Oppsett av betaling tok for lang tid. Vennligst prøv igjen.'
	},
	Checkout: {
		Title: () => 'Kasse',
		Steps: {
			Shipping: () => 'Frakt',
			Payment: () => 'Betaling',
			Review: () => 'Gjennomgang',
			Confirmation: () => 'Bekreftelse'
		},
		Shipping: {
			Address: () => 'Leveringsadresse',
			Method: () => 'Fraktmetode',
			FirstName: () => 'Fornavn',
			LastName: () => 'Etternavn',
			AddressLine1: () => 'Adresse',
			AddressLine2: () => 'Leilighet, suite, o.l. (valgfritt)',
			City: () => 'By',
			PostalCode: () => 'Postnummer',
			Country: () => 'Land',
			Phone: () => 'Telefonnummer'
		},
		Review: {
			OrderSummary: () => 'Bestillingssammendrag',
			ShippingInfo: () => 'Fraktinformasjon',
			PaymentInfo: () => 'Betalingsinformasjon',
			PlaceOrder: () => 'Legg inn bestilling'
		}
	},
	Orders: {
		Title: () => 'Bestillingshistorikk',
		Empty: () => 'Ingen bestillinger funnet',
		OrderNumber: (arg0: string) => 'Bestilling #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Bestilt den ' + shortFormatter('nb', arg0),
		Status: {
			Pending: () => 'Venter',
			Processing: () => 'Behandles',
			Shipped: () => 'Sendt',
			Delivered: () => 'Levert',
			Cancelled: () => 'Avbrutt',
			Refunded: () => 'Refundert'
		},
		TrackOrder: () => 'Spor bestilling',
		Reorder: () => 'Bestill på nytt',
		ViewReceipt: () => 'Se kvittering',
		OrderDetails: () => 'Bestillingsdetaljer'
	},
	Receipt: {
		Title: () => 'Kvittering',
		TitleWithOrderNumber: (arg0: string) => 'Kvittering ' + String(arg0),
		NotFound: () => 'Kvittering ikke funnet.',
		OrderId: () => 'Bestillings-ID',
		OrderNumber: (arg0: string) => '#' + String(arg0),
		Total: () => 'Totalt',
		DownloadPDF: () => 'Last ned PDF',
		ShowPickupCode: () => 'Vis hentekode',
		PickupCodeMessage: () => 'Vis denne koden for å hente bestillingen din.',
		PickupCode: () => 'Hentekode',
		BackToReceipts: () => 'Tilbake til kvitteringer'
	},
	Receipts: {
		Title: () => 'Tidligere bestillinger',
		Empty: () => 'Ingen bestillinger funnet',
		OrderNumber: (arg0: string) => 'Bestilling #' + String(arg0),
		OrderDate: (arg0: DateInput) => 'Bestilt den ' + shortFormatter('nb', arg0),
		Items: (args: { count: number }) =>
			String(args.count) + ' ' + plural('nb', args.count, { one: 'vare', other: 'varer' }),
		ViewReceipt: () => 'Se kvittering',
		BackToHome: () => 'Tilbake til forsiden',
		MoreItems: (arg0: number) => '+' + String(arg0),
		Unknown: () => 'Ukjent'
	},
	Auth: {
		SignIn: () => 'Logg inn',
		SignUp: () => 'Registrer deg',
		SignOut: () => 'Logg ut',
		Email: () => 'E-post',
		Password: () => 'Passord',
		ConfirmPassword: () => 'Bekreft passord',
		ForgotPassword: () => 'Glemt passord?',
		CreateAccount: () => 'Opprett konto',
		AlreadyHaveAccount: () => 'Har du allerede en konto?',
		DontHaveAccount: () => 'Har du ikke en konto?',
		ResetPassword: () => 'Tilbakestill passord',
		RememberMe: () => 'Husk meg',
		PhoneNumber: () => 'Telefonnummer',
		SSN: () => 'Fødselsnummer',
		TaktikalPhoneMethod: () => 'Elektronisk ID',
		TaktikalSsnMethod: () => 'Autentiseringsapp',
		VerificationCode: (arg0: string) => 'Bekreftelseskode: ' + String(arg0),
		SignInToYourAccount: () => 'Logg inn på kontoen din',
		SignIntoYourAccountDescription: () => 'Logg inn for å se lojalitetskortet ditt, kvitteringer og mer.',
		Continue: () => 'Fortsett',
		AuthenticationTimedOut: () => 'Autentiseringsforespørselen ble tidsavbrutt. Vennligst prøv igjen.',
		Retry: () => 'Prøv igjen'
	},
	LoyaltyCard: {
		Title: () => 'Lojalitetskort',
		CardNumber: () => 'Kortnummer',
		AvailablePoints: () => 'Tilgjengelige poeng',
		AddToWallet: () => 'Legg til lommebok',
		ShowReceipts: () => 'Se kvitteringer',
		Disclaimer: () => 'Poeng er gyldige i 3 år fra datoen du tjente dem.',
		JoinProgram: () => 'Bli med i lojalitetsprogram',
		JoinBenefitsTitle: () => 'Bli med i lojalitetsprogrammet vårt',
		JoinBenefitPoints: () => 'Samle poeng ved hvert kjøp',
		JoinBenefitOffers: () => 'Få tilgang til eksklusive medlemstilbud',
		PointsHistory: () => 'Poenghistorikk',
		EmptyHistory: () => 'Ingen poenghistorikk ennå',
		NoCard: () => 'Ingen lojalitetskort funnet'
	},
	Profile: {
		Language: () => 'Språk',
		Logout: () => 'Logg ut',
		LogoutConfirm: () => 'Logg ut',
		LogoutConfirmMessage: () => 'Er du sikker på at du vil logge ut?',
		DeleteAccount: () => 'Slett konto',
		DeleteAccountConfirm: () => 'Slett konto',
		DeleteAccountConfirmMessage: () => 'Er du sikker på at du vil slette kontoen din? Dette kan ikke angres.',
		DeleteAccountFinalConfirm: () => 'Er du helt sikker?',
		DeleteAccountFinalConfirmMessage: () =>
			'Dette er permanent og kan ikke angres. Alle dataene dine vil bli slettet. Det er ingen vei tilbake.',
		DeleteAccountConfirmButton: () => 'Ja, slett kontoen min'
	},
	Errors: {
		Generic: () => 'Noe gikk galt. Vennligst prøv igjen.',
		Network: () => 'Nettverksfeil. Vennligst sjekk tilkoblingen din.',
		NotFound: () => 'Side ikke funnet',
		Unauthorized: () => 'Vennligst logg inn for å fortsette',
		Validation: {
			Required: () => 'Dette feltet er påkrevd',
			InvalidEmail: () => 'Vennligst skriv inn en gyldig e-postadresse',
			PasswordTooShort: () => 'Passordet må være minst 8 tegn',
			PasswordsDoNotMatch: () => 'Passordene stemmer ikke overens',
			InvalidFormat: () => 'Ugyldig format'
		}
	}
}

export const locales = {
	en,
	is,
	nb
}
